module.exports = __webpack_public_path__ + "static/assets/40221c01d52ac94f4c6f58c3d19717a2.svg";